// 生成路由排除内容，不带后缀名转换成“/文件名/”格式
export const ROUTER_EXCLUDE = [
  'login',
  'forget',
  'components',
  'utils',
  'lib',
  'hooks',
  'model.tsx',
  '404.tsx',
];
